export default __webpack_public_path__ + "static/media/icon_language.b569d709.svg";